<template>
  <!-- 支付控制弹窗 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="支付控制"
      width="400px"
      @close="closeDialog"
    >
      <el-form
        :model="formData"
        ref="replyForm"
        label-width="150px"
        size="small"
      >
        <el-form-item prop="low_price" label="用户最低充值金额">
          <el-input
            v-model="formData.low_price"
            placeholder="请输入最低充值金额"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="day_max_amount" label="每日用户最大总充值">
          <el-input
            v-model="formData.day_max_amount"
            placeholder="每日用户最大总充值金额"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="month_max_amount" label="每月用户最大总充值">
          <el-input
            v-model="formData.month_max_amount"
            placeholder="每月用户最大总充值金额"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button
            v-if="orderStatus != 2"
            type="primary"
            @click="submit"
            :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getData, delApiData, getApiData, postApiData, patchApiData } from '../../http'
export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      formData: {
        low_price: undefined,
        day_max_amount: undefined,
        month_max_amount: undefined,
      },
      replyText: '',//回复内容
      orderStatus: 1,//订单状态
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getData()
      }
    },
  },
  created() {
  },
  methods: {
    getData() {
      //获取数据
      getApiData('pay_control').then((res) => {
        this.formData = res
      }).finally(() => {

      })
    },
    submit() {
      // 保存数据
      let params = this.formData
      patchApiData('pay_control', params).then((res) => {
        this.$message.success("保存成功！")
        this.$emit('close')
      }).finally(() => {

      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>